import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { AppRoutingModule } from './modules/app-routing.module';
import { BootstrapModule } from './modules/bootstrap.module';

import { AppComponent } from './app.component';
import { LoaderComponent } from './components/loader/loader.component';

import { AuthGuard } from './route-guards/auth/auth.guard';

import { CognitoService } from './services/cognito/cognito.service';
import { AwsSignerService } from './services/aws-signer/aws-signer.service';

import { DashboardModule } from './modules/dashboard/dashboard.module';
import { ClientModule } from './modules/client/client.module';
import { CampaignModule } from './modules/campaign/campaign.module';
import { ProviderModule } from './modules/provider/provider.module';
import { UsersModule } from './modules/users/users.module';
import { OutletModule } from './modules/outlet/outlet.module';
import { DashreportModule } from './modules/dashreport/dashreport.module';
import { ProgressModule } from './modules/progress/progress.module';
import { LoginModule } from './modules/login/login.module';
import { ApacDetailModule } from './modules/apac-detail/apac-detail.module';
import { AppRoutingService } from './modules/app-routing.service';
import { DateAdapter } from '@angular/material';
import { CustomDateAdapter } from './utils/customDataAdapter';
import { NgxLoadingModule } from 'ngx-loading';
import { SendTestProfileModule } from './modules/send-test-profile/send-test-profile.module';

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    BootstrapModule,
    HttpClientModule,
    DashboardModule,
    ApacDetailModule.forRoot(),
    ClientModule.forRoot(),
    CampaignModule.forRoot(),
    ProviderModule.forRoot(),
    UsersModule.forRoot(),
    OutletModule.forRoot(),
    DashreportModule.forRoot(),
    ProgressModule.forRoot(),
    LoginModule.forRoot(),
    SendTestProfileModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  providers: [
    AuthGuard,
    CognitoService,
    AwsSignerService,
    AppRoutingService,
    {
      provide: DateAdapter, useClass: CustomDateAdapter
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts